// extracted by mini-css-extract-plugin
module.exports = {"noquotes":"NoQuotesFound_noquotes__3zT0X"};